import { render, staticRenderFns } from "./detailTree.vue?vue&type=template&id=6c61afe5&scoped=true"
import script from "./detailTree.vue?vue&type=script&lang=js"
export * from "./detailTree.vue?vue&type=script&lang=js"
import style0 from "./detailTree.vue?vue&type=style&index=0&id=6c61afe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61afe5",
  null
  
)

export default component.exports